/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-11 22:56:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-26 18:34:47
 * @FilePath: /code/zeelool-nextjs/src/api/cart.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { BaseCartRequestData } from '@/app/_lens-components/types';
import { httpRequest } from '@/utils/axios';
import { IGetCartPrice } from './types/cart';

// 获取购物车列表
export const getNewCartList = (params: any) => httpRequest('GET:/api/cart/v2/lists', { params });

// 获取购物车列表（旧版本）
export const getCartList = () => httpRequest('GET:/api/cart/lists');

// 加入购物车
export const addToCart = (data: BaseCartRequestData) => {
  // 删除 origin_option 字段，避免修改 data 影响其他逻辑
  if (data && data.origin_option) {
    data = Object.assign({}, data);
    delete data.origin_option;
  }
  return httpRequest('POST:/api/cart/store', { data });
};

// 更新购物车
export const updateCart = (data: BaseCartRequestData) => {
  // 删除 origin_option 字段，避免修改 data 影响其他逻辑
  if (data && data.origin_option) {
    data = Object.assign({}, data);
    delete data.origin_option;
  }
  return httpRequest('PUT:/api/cart/update', { data });
};

// 删除购物车
export const deleteCart = (data: { cart_ids?: number[] }) =>
  httpRequest('DELETE:/api/cart/delete', { data });

// 加入特殊类型到购物车
export const specialCartStore = (data: {
  currency?: string;
  data?: Array<{
    type?: number;
    relation_id?: number;
    products?: Array<{
      product_id?: number;
      conversion_qty?: number;
      cart_id?: string;
      option?: any;
      prescription_recognition_id?: number;
    }>;
  }>;
}) => httpRequest('POST:/api/cart/special_store', { data });

// 刷新购物车（执行合并购物车，自动删除购物车
export const refreshCarts = () => httpRequest('GET:/api/cart/refresh');

// 获取购物车总的价格
export const getSubTotalPrice = (params: IGetCartPrice) =>
  httpRequest('GET:/api/cart/get_cart_price', { params } as any);

// 获取包邮政策
export const getFreeShippingPolicy = (params: { currency?: string; cart_ids?: number[] }) =>
  httpRequest('GET:/api/cart/free_shipping_policy', { params } as any);

// 兑换券使用&取消使用
export const useCoupon = (data: { cart_id?: number; product_id?: number; coupon_id?: number }) =>
  httpRequest('POST:/api/cart/coupon', { data });

// 获取套装能选择的商品列表
export const getPackageProducts = (data: { package_id?: number }) =>
  httpRequest('GET:/api/cart/get_package_products', { data });

// 购物车跳转结算页面前检查
export const checkCartBeforeCheckout = (data: { cart_ids?: string[] }) =>
  httpRequest('POST:/api/cart/check', { data });

// 获取第二件半价信息
export const getHalfPrice = () => httpRequest('GET:/api/public/half_price');

// 购物车特殊商品列表（套装、兑换品等）
export const getSpecialCartLists = () => httpRequest('GET:/api/cart/special_lists');

// 兑换券使用&取消使用
export const applyCartCoupon = (data: { cart_id: number; coupon_id: number }) =>
  httpRequest('POST:/api/cart/coupon', { data });
